// components/TextInput.jsx

import { useSelector } from "react-redux";
import PropTypes from "prop-types";


const  Input = ({
  name,
  type,
  placeholder,
  value,
  onChange,
  required,
  disabled,
  className,
  minimumValue,
  maximumValue,
  sx = {},
  readOnly,
}) => {


  const { theme } = useSelector((state) => state.theme);
  return (
    <input
      name={name}
      type={type}
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      disabled={disabled}
      min={minimumValue}
      max={maximumValue}
      required={required ? true : false}
      className={`${
        theme === "light" ? "" : "bg-darkInput "
      } border p-2  text-sm w-full ${className || ""}`}
      style={sx}
      readOnly={readOnly}
    />
  );
};

Input.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  minimumValue: PropTypes.number,
  maximumValue: PropTypes.number,
  sx: PropTypes.object,
  readOnly: PropTypes.bool,
};

Input.defaultProps = {
  type: "text",
  placeholder: "",
  value: "",
  required: false,
  disabled: false,
  className: "",
  minimumValue: undefined,
  maximumValue: undefined,
  sx: {},
  readOnly: false,
};

export default Input;
